import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    parcoursList : [],
    level:"",
    selectedParcours:{},
}
const parcoursSlice = createSlice({
    name:'parcours',
    initialState,
    reducers:{
        setParcoursList:(state,{payload})=>{
            state.parcoursList = payload
        },
        setSelectedLevel:(state,{payload})=>{
            state.level = payload
        },
        setSelectedParcours:(state,{payload})=>{
            state.selectedParcours = payload
        },
    }
})

export const { setParcoursList,setSelectedParcours,setSelectedLevel} = parcoursSlice.actions
export default parcoursSlice.reducer